module.exports = require("@glimmer/env");